<template>
  <BaseButton
    :class="[
      {
        'cursor-not-allowed bg-light-disabled-background text-light-disabled-text dark:border-dark-disabled-background dark:bg-dark-disabled-background dark:text-dark-disabled-text':
          isDisabled,
      },
      {
        'border-primary-2 text-primary-2 hover:bg-primary-3 hover:dark:bg-dark-2':
          !isDisabled,
      },
    ]"
    :disabled="isDisabled"
  >
    <em v-if="icon" :class="['mdi', icon]"></em>
    {{ label }}
  </BaseButton>
</template>
<script setup lang="ts">
import BaseButton from '@/components/UI/Button/BaseButton.vue';

const props = defineProps<{
  label: string;
  icon?: string;
  isDisabled?: boolean;
}>();
</script>
